import type { RiskListWithEntitiesResponse } from '@risksmart-app/drizzle/src/dto';
import type { GetRiskListWithEntitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskListWithEntitiesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetRiskListWithEntities = createQueryHook<
  Record<string, never>,
  RiskListWithEntitiesResponse,
  GetRiskListWithEntitiesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.risk.riskListWithEntities.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    risk: data.risk,
    node: data.node,
  }),
  graphqlDocument: GetRiskListWithEntitiesDocument,
});
